class StyleUtils {
  constructor() {
    this.initializeScrollbar();
  }
  insertStyle(style: string) {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = style;
    document.head.appendChild(styleElement);
  }

  initializeScrollbar() {
    const style = `
      html {
        /* 预留滚动条空间 - 支持最新浏览器 */
        scrollbar-gutter: stable;
        /* 备用方案 - 兼容旧版浏览器 */
        overflow-y: scroll;
        /* 火狐 */
        scrollbar-width: none;
      }
  
      /* 现代浏览器滚动条样式 (Chrome/Edge/Safari) */
      @media (min-width: 900px) {
        ::-webkit-scrollbar {
          width: 4px;
          height: 4px;
          background-color: transparent;
        }
  
        ::-webkit-scrollbar-track {
          border-radius: 4px;
        }
  
        ::-webkit-scrollbar-thumb {
          background: #E5E7EB;
          border-radius: 4px;
          border: 2px solid transparent;
          background-clip: content-box;
          transition: background 0.3s;
        }
  
        :hover::-webkit-scrollbar-thumb {
          background: #E5E7EB;
        }
      }
  
      @media (max-width: 899px) {
        ::-webkit-scrollbar {
          display: none;
        }
      }
  
      /* Firefox 滚动条样式 */
      @supports (-moz-appearance: none) {
        html {
          scrollbar-width: thin;
          scrollbar-color: #E5E7EB rgba(0, 0, 0, 0.05);
        }
      }
      `;
    this.insertStyle(style);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default StyleUtils;
